import {NavLink} from "react-router-dom";
import classNames from "classnames";
import { ReactNode } from "react";
import { Button } from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquare } from "@fortawesome/pro-regular-svg-icons";

interface LinkProps {
  className?: string;
  isExternal?: boolean;
  onClick?: () => void;
  replace?: boolean;
  text: string;
  to: string;
  variant?: "primary" | "link" | "button" | "none";
  children?: ReactNode | ReactNode[];
  disabled?: boolean;
}

export const Link = ({
  className,
  isExternal,
  onClick,
  replace,
  text,
  to,
  variant = "link",
  children,
  disabled,
}: LinkProps) => {
  let style = "";

  switch (variant) {
  case "link":
    style = "underline text-gray-500 hover:text-unleashed-pink";
    break;
  case "primary":
    style = "underline text-unleashed-pink [@media(pointer:fine)]:hover:opacity-75";
    break;
  case "button":
    style = "block rounded text-center px-4 py-0.5 select-none text-white bg-unleashed-pink border border-unleashed-pink";
    break;
  }

  if (disabled) {
    return (
      <Button title={text} variant="none" disabled={true}
        className={classNames(className, style)}>
        {children ?? text}
      </Button>
    );
  }

  if (isExternal) {
    return (
      <a href={to} target="_blank" className={classNames(className, style)}
        title={text} rel="noreferrer" onClick={onClick}>
        {children ?? text}
        <FontAwesomeIcon className="ml-1" icon={faExternalLinkSquare}/>
      </a>
    );
  }

  return (
    <NavLink to={to} replace={replace} onClick={onClick} title={text}
      className={classNames(className, style)}>
      {children ?? text}
    </NavLink>
  );
};
